interface V3IconInfoProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconInfo = ({ stroke = "black" }: V3IconInfoProps) => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" stroke={stroke}>
    <circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" />
</svg>
